module.exports = "/_next/static/images/ScanPreview1-ae607938f0b630a0544005d670874089.png";